import { TrendingDown, TrendingUp } from 'lucide-react'
import { Area, AreaChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis } from 'recharts'

import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from '@/components/ui/card'

type ChartDataItem = {
  date: string
  commits: number
}

export function CommitsChart({ data, trend }: { data: ChartDataItem[]; trend: number }) {
  return (
    <Card>
      <CardHeader className="pb-4">
        <CardTitle>Daily Activity</CardTitle>
        <CardDescription>Code changes frequency over the last 30 days</CardDescription>
      </CardHeader>
      <CardContent className="pb-2">
        <div className="h-[220px] w-full [&_.recharts-layer]:outline-none [&_.recharts-surface]:outline-none [&_.recharts-wrapper]:outline-none [&_svg]:outline-none [&_svg:focus]:outline-none">
          <ResponsiveContainer width="100%" height="100%">
            <AreaChart data={data} margin={{ top: 8, left: 4, right: 8, bottom: 0 }}>
              <CartesianGrid vertical={false} stroke="hsl(var(--border))" strokeOpacity={0.5} />
              <XAxis dataKey="date" tickLine={false} tickMargin={10} axisLine={false} />
              <Tooltip
                cursor={{ stroke: 'hsl(var(--border))' }}
                contentStyle={{
                  background: 'hsl(var(--background))',
                  border: '1px solid hsl(var(--border))',
                  borderRadius: 8,
                }}
              />
              <Area
                dataKey="commits"
                type="monotone"
                fill="#EEBF31"
                fillOpacity={0.35}
                stroke="#E6A91A"
                strokeWidth={2}
                isAnimationActive={false}
              />
            </AreaChart>
          </ResponsiveContainer>
        </div>
      </CardContent>
      <CardFooter className="flex-col items-start gap-2 pt-4 text-sm">
        <div className="flex items-center gap-2 font-medium">
          <span className="leading-none">
            Trending {trend >= 0 ? 'up' : 'down'} by{' '}
            <span className={trend >= 0 ? 'text-green-700' : 'text-red-600'}>
              {Math.abs(trend).toLocaleString(undefined, {
                maximumFractionDigits: 1,
                minimumFractionDigits: 0,
              })}
              %
            </span>{' '}
            this month
          </span>
          {trend >= 0 ? (
            <TrendingUp className="size-4 text-green-700" />
          ) : (
            <TrendingDown className="size-4 text-red-600" />
          )}
        </div>
        <div className="text-muted-foreground leading-none">Showing daily code changes for the past 30 days</div>
      </CardFooter>
    </Card>
  )
}
